var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',{attrs:{"title":"Manage Clients"},scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('create-client')]},proxy:true}])},[_vm._v(" "),_c('clients-table',{attrs:{"clients":_vm.clients}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }